import { PlatformsAuthEvent, PlatformsAuthLoginErrorEvent } from '~/types';

export function isAuthServiceSSOLoginError(
  evnt: PlatformsAuthEvent
): evnt is PlatformsAuthLoginErrorEvent {
  return evnt.type === 'authservice-sso-login-error';
}
